// Argon Dashboard 2 MUI Examples
import React, { useMemo } from "react";

import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";

const CustomerLineChart = () => {
  return (
    <DefaultLineChart
      title="Ricerche e Visite"
      chart={{
        labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [
          {
            label: "Organic Search",
            color: "info",
            data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
          },
          {
            label: "Referral",
            color: "dark",
            data: [30, 90, 40, 140, 290, 290, 340, 230, 400],
          },
          {
            label: "Direct",
            color: "primary",
            data: [40, 80, 70, 90, 30, 90, 140, 130, 200],
          },
        ],
      }}
    />
  );
};

export default React.memo(CustomerLineChart);

export const CustomerLineChartDashboard = () => {
  return (
    <DefaultLineChart
      title="Google My Business"
      chart={{
        labels: ["Gen", "Feb", "Mar", "Apr"],
        datasets: [
          {
            label: "Ricerca Organica",
            color: "info",
            data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
          },
          {
            label: "Visite Dirette",
            color: "dark",
            data: [30, 90, 40, 140, 290, 290, 340, 230, 400],
          },
          {
            label: "Click",
            color: "primary",
            data: [40, 80, 70, 90, 30, 90, 140, 130, 200],
          },
        ],
      }}
    />
  );
};
